import { emailTranscript } from '@/redux/app/actions/event';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';

import { ticketContactEmailSelector } from '@/redux/app/selectors/ticket';
import { UserInfoContext } from '../../user/user-info';

export interface TicketEmailModalProps {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
  subdomain: string;
  ticket: string;
}

export const TicketEmailModal = ({
  setShowModal,
  showModal,
  subdomain,
  ticket,
}: TicketEmailModalProps) => {
  const contactEmail = useSelector(_.partial(ticketContactEmailSelector, ticket));
  const dispatch = useDispatch();
  const [input, setInput] = React.useState(contactEmail || '');
  const { email } = React.useContext(UserInfoContext);

  React.useEffect(() => {
    setInput(contactEmail || '');
    setShowModal(false);
  }, [ticket]);

  if (!showModal) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(emailTranscript({
      subdomain,
      ticketUuid: ticket,
      email: input,
    }));
  };

  const handleInput = (e) => {
    const val = e.currentTarget.value;
    setInput(val);
  };

  const placeholder = `Ex. ${email}`;

  return (
    <div id="email-modal">
      <div className="container">
        <div className="close-modal">
          <button
            type="button"
            className="button"
            onClick={() => setShowModal(false)}
          >
            𐄂
          </button>
        </div>
        <div className="modal-contents">
          <form
            className="email-transcript-form"
            onSubmit={handleSubmit}
          >
            <h3>Email a transcript of this conversation to:</h3>
            <input
              type="text"
              className="email-input"
              value={input}
              placeholder={placeholder}
              onChange={handleInput}
            />
            <input
              type="submit"
              className="email-send"
              value="Send"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
